import { render, staticRenderFns } from "./TableRowBase.vue?vue&type=template&id=c884d63a&scoped=true&lang=pug"
import script from "./TableRowBase.vue?vue&type=script&lang=ts"
export * from "./TableRowBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c884d63a",
  null
  
)

export default component.exports